<div class="tx-progressbar" [style]="{ height: height + 'px', fontSize: height + 'px' }">
	<div *ngIf="text !== ''" class="text">
		{{ text }}
	</div>
	<div class="tx-progressbar-bar-background"></div>
	<div class="tx-progressbar-bar" [style]="{ width: value + '%', backgroundColor: color }"></div>
</div>
